import { useTranslation } from "react-i18next";
import Footer from "../../components/Footer";
import DFNavbar from "../../components/Navbar";
import { ScrollToTop } from "../../components/ScrollToTop";
import i18n from "../../i18n/configs";
import QAContentEN from "./QAContentEN";
import QAContentJA from "./QAContentJA";
import { Helmet } from "react-helmet";

/**
 * Q&A画面ベース
 * @returns JSX.Element
 */
const QATop = () => {
    const { t } = useTranslation();

    return (
        <div className="flex min-h-screen flex-col">
            <Helmet title={"QA | DF WebService"} />
            <ScrollToTop />
            <DFNavbar bottomPadding={true} />
            <div className="flex-grow items-center justify-center px-6 py-8 pt-20 lg:px-20">
                <h1 className="mb-4 mt-2 text-center text-2xl font-bold text-gray-800 sm:text-3xl">
                    {t("CommonLabel.faq")}
                </h1>

                <div className="mx-auto mt-10 flex max-w-3xl items-center justify-center">
                    {i18n.language === "ja"
                        ? "「よくあるご質問」ページは移行しました。"
                        : "The FAQ page has been migrated."}
                </div>
                <div className="mx-auto flex max-w-3xl items-center justify-center">
                    <a
                        href={
                            i18n.language === "ja"
                                ? "https://deepforest-tech.co.jp/faq/"
                                : "https://deepforest-tech.co.jp/en/faq/"
                        }
                        className="link-text mt-4 text-sm font-bold"
                    >
                        {i18n.language === "ja" ? "新しいページへ移動する" : "Go to the new page."}
                    </a>
                </div>

                {/* {i18n.language === "ja" ? <QAContentJA /> : <QAContentEN />} */}
            </div>
            <Footer />
        </div>
    );
};

export default QATop;
